import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as appPropTypes from './appPropTypes';
import { withStyles } from '@material-ui/core/styles';
import isElectron from 'is-electron';
import * as roomActions from '../actions/roomActions';
import * as toolareaActions from '../actions/toolareaActions';
import * as settingActions from '../actions/settingsActions';
import * as chatActions from '../actions/chatActions';
import { idle } from '../utils';
import FullScreen from './FullScreen';
import { FormattedMessage } from 'react-intl';
import CookieConsent from 'react-cookie-consent';
import CssBaseline from '@material-ui/core/CssBaseline';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import Notifications from './Notifications/Notifications';
import MeetingDrawer from './MeetingDrawer/MeetingDrawer';
import AudioPeers from './PeerAudio/AudioPeers';
import FullScreenView from './VideoContainers/FullScreenView';
import VideoWindow from './VideoWindow/VideoWindow';
import BottomNavi from './Controls/BottomNavi';
import WakeLock from 'react-wakelock-react16';
import ExtraVideo from './Controls/ExtraVideo';

import Home from './SecondDoor/Host/Home';
import MemoPage from './SecondDoor/Host/MemoPage';
import CallPage from './SecondDoor/Host/CallPage';
import Setting from './SecondDoor/Host/Setting';
import ToDo from './SecondDoor/Host/ToDo';
import CallHistory from './SecondDoor/Host/CallHistory';
import OnCallDialog from './SecondDoor/Host/OnCallDialog';
import OnInviteDialog from './SecondDoor/Host/OnInviteDialog';
import AccessWarningDialog from './SecondDoor/Host/AccessWarningDialog';
import ServiceStoppedPage from './SecondDoor/Host/ServiceStoppedPage';

import GuestHome from './SecondDoor/Guest/GuestHome';
import GuestBottomNavi from './SecondDoor/Guest/GuestBottomNavi';

import {
	peersLengthSelector, peersValueSelector
} from './Selectors';

// firebase
import { getStorage, ref, deleteObject } from 'firebase/storage';

const TIMEOUT = window.config.hideTimeout || 5000;

const styles = (theme) =>
	({
		root :
		{
			display              : 'flex',
			width                : '100%',
			height               : '100%',
			backgroundAttachment : 'fixed',
			backgroundPosition   : 'center',
			backgroundSize       : 'cover',
			backgroundRepeat     : 'no-repeat',
			backgroundColor      : '#f4f4f4',
			alignItems           : 'center',
			flexDirection        : 'column',
			margin               : '0 auto',
			zIndex               : 1,
			padding              : '2%',
			justifyContent       : 'center',
			overflow             : 'auto'
		},
		rootGuest :
		{
			display                      : 'flex',
			width                        : '100%',
			height                       : '100%',
			backgroundAttachment         : 'fixed',
			backgroundPosition           : 'center',
			backgroundSize               : 'cover',
			backgroundRepeat             : 'no-repeat',
			backgroundColor              : '#919191',
			alignItems                   : 'center',
			flexDirection                : 'column',
			margin                       : '0 auto',
			zIndex                       : 1,
			padding                      : '2%',
			overflow                     : 'auto',
			'@media (max-height: 625px)' : {
				padding : '0 2%'
			}
		},
		rootM :
		{
			display              : 'flex',
			width                : '100%',
			height               : '100%',
			backgroundAttachment : 'fixed',
			backgroundPosition   : 'center',
			backgroundSize       : 'cover',
			backgroundRepeat     : 'no-repeat',
			backgroundColor      : '#f4f4f4',
			alignItems           : 'center',
			flexDirection        : 'column',
			margin               : '10% auto',
			zIndex               : 1,
			justifyContent       : 'flex-start',
			overflow             : 'hidden'
		},
		rootUseMobile :
		{
			display              : 'flex',
			width                : '100%',
			height               : '100%',
			backgroundAttachment : 'fixed',
			backgroundPosition   : 'center',
			backgroundSize       : 'cover',
			backgroundRepeat     : 'no-repeat',
			backgroundColor      : '#f4f4f4',
			alignItems           : 'center',
			flexDirection        : 'column',
			margin               : '2% auto 0 auto',
			zIndex               : 1,
			justifyContent       : 'flex-start',
			overflow             : 'hidden'
		},
		roomML :
		{
			display              : 'flex',
			width                : '100%',
			height               : '100%',
			backgroundAttachment : 'fixed',
			backgroundPosition   : 'center',
			backgroundSize       : 'cover',
			backgroundRepeat     : 'no-repeat',
			backgroundColor      : '#f4f4f4',
			alignItems           : 'center',
			flexDirection        : 'row-reverse',
			margin               : '0 auto',
			zIndex               : 1,
			justifyContent       : 'center',
			overflow             : 'hidden'
		},
		drawer :
		{
			width                          : '30vw',
			flexShrink                     : 0,
			[theme.breakpoints.down('lg')] :
			{
				width : '30vw'
			},
			[theme.breakpoints.down('md')] :
			{
				width : '50vw'
			},
			[theme.breakpoints.down('sm')] :
			{
				width : '70vw'
			},
			[theme.breakpoints.down('xs')] :
			{
				width : '90vw'
			}
		},
		drawerPaper :
		{
			width                          : '30vw',
			[theme.breakpoints.down('lg')] :
			{
				width : '30vw'
			},
			[theme.breakpoints.down('md')] :
			{
				width : '50vw'
			},
			[theme.breakpoints.down('sm')] :
			{
				width : '70vw'
			},
			[theme.breakpoints.down('xs')] :
			{
				width : '90vw'
			}
		},
		backgroundImage :
		{
			position : 'fixed',
			width    : '100vw',
			height   : '100vh',
			zIndex   : -1
		},
		logo :
		{
			width  : 'auto',
			height : '4%',
			margin : '2% auto 3% auto'
		},
		logoML :
		{
			width     : '14%',
			height    : 'auto',
			margin    : '0 auto',
			transform : 'rotate(90deg)'
		}
	});

class Room extends React.PureComponent
{
	constructor(props)
	{
		super(props);

		this.fullscreen = new FullScreen(document);

		this.state =
		{
			fullscreen : false
		};
	}

	waitForHide = idle(() =>
	{
		this.props.setToolbarsVisible(false);
	}, TIMEOUT);

	handleMovement = () =>
	{
		// If the toolbars were hidden, show them again when
		// the user moves their cursor.
		if (!this.props.room.toolbarsVisible)
		{
			// this.props.setToolbarsVisible(true);
		}

		// this.waitForHide();
	}

	componentDidMount()
	{
		if (this.fullscreen.fullscreenEnabled)
		{
			this.fullscreen.addEventListener('fullscreenchange', this.handleFullscreenChange);
		}

		window.addEventListener('mousemove', this.handleMovement);
		window.addEventListener('touchstart', this.handleMovement);
	}

	componentWillUnmount()
	{
		if (this.fullscreen.fullscreenEnabled)
		{
			this.fullscreen.removeEventListener('fullscreenchange', this.handleFullscreenChange);
		}

		window.removeEventListener('mousemove', this.handleMovement);
		window.removeEventListener('touchstart', this.handleMovement);
	}

	handleToggleFullscreen = () =>
	{
		if (this.fullscreen.fullscreenElement)
		{
			this.fullscreen.exitFullscreen();
		}
		else
		{
			this.fullscreen.requestFullscreen(document.documentElement);
		}
	};

	handleFullscreenChange = () =>
	{
		this.setState({
			fullscreen : this.fullscreen.fullscreenElement !== null
		});
	};

	// delete unneeded shared files and reser settings.holding
	componentDidUpdate(prevProps)
	{
		const { peersLength } = prevProps;

		// check if the call ended
		if (peersLength > 0 && this.props.peersLength === 0)
		{
			// reset settings.holding
			this.props.setHolding(false);

			// reset room.call
			this.props.setRoomCall(null);

			// stop screen sharing
			if (this.props.roomClient.isHost())
			{
				this.props.roomClient.disableScreenSharing();
			}
			// reset guest's peerId when call finished, in order to distinguish each call
			else
			{
				this.props.roomClient.resetPeerId();
			}

			// the other person hang up/leave && sharedFiles exist
			if (this.props.room.makeCallEnd === false)
			{
				const sharedFiles = [];

				this.props.chat.forEach((item) =>
				{
					if (item.type === 'file' && item.fileShareUrl)
					{
						sharedFiles.push(item.fileShareUrl);
					}
				});

				if (sharedFiles.length > 0)
				{
					const storage = getStorage();

					for (const url of sharedFiles)
					{
						try
						{
							// Create a reference to the file to delete
							const desertRef = ref(storage, url);

							deleteObject(desertRef);
						}
						catch
						{
							// do nothing
						}
					}
				}
			}

			// make the call ended by him/herself
			else if (
				this.props.room.makeCallEnd === true
			)
			{
				// reset room.makeCallEnd for next call
				this.props.setMakeCallEnd(false);
			}
		}

		// start call
		if (peersLength === 0 && this.props.peersLength > 0)
		{
			// clear chat
			this.props.clearChat();

			// clear memo
			this.props.setMemo(null);
		}
	}

	render()
	{
		const {
			roomClient,
			room,
			browser,
			advancedMode,
			showNotifications,
			drawerOverlayed,
			toolAreaOpen,
			toggleToolArea,
			classes,
			theme,
			currentNaviTab,
			isMobile,
			orientation,
			useMobileView,
			serviceStopped
		} = this.props;

		const container = window !== undefined ? window.document.body : undefined;

		if (roomClient.isHost())
		{
			if (serviceStopped)
			{
				return (<ServiceStoppedPage />);
			}
			else
			{
				return (
					<div className={classes.root}>
						{ !isElectron() &&
						<CookieConsent
							buttonText={
								<FormattedMessage
									id='room.consentUnderstand'
									defaultMessage='I understand'
								/>
							}
							style={{ display: 'none' }}
						>
							<FormattedMessage
								id='room.cookieConsent'
								defaultMessage='This website uses cookies to enhance the user experience'
							/>
						</CookieConsent>
						}

						<FullScreenView advancedMode={advancedMode} />

						<VideoWindow advancedMode={advancedMode} />

						<AudioPeers />

						{ showNotifications &&
						<Notifications />
						}

						<CssBaseline />

						{ (isMobile || drawerOverlayed) ?
							<nav>
								<Hidden implementation='css'>
									<SwipeableDrawer
										container={container}
										variant='temporary'
										anchor={theme.direction === 'rtl' ? 'right' : 'left'}
										open={toolAreaOpen}
										onClose={() => toggleToolArea()}
										onOpen={() => toggleToolArea()}
										classes={{
											paper : classes.drawerPaper
										}}
										ModalProps={{
											keepMounted : true // Better open performance on mobile.
										}}
									>
										<MeetingDrawer roomClient={roomClient} closeDrawer={toggleToolArea} />
									</SwipeableDrawer>
								</Hidden>
							</nav>
							:
							<nav className={toolAreaOpen ? classes.drawer : null}>
								<Hidden implementation='css'>
									<Drawer
										variant='persistent'
										anchor={theme.direction === 'rtl' ? 'right' : 'left'}
										open={toolAreaOpen}
										onClose={() => toggleToolArea()}
										classes={{
											paper : classes.drawerPaper
										}}
									>
										<MeetingDrawer roomClient={roomClient} closeDrawer={toggleToolArea} />
									</Drawer>
								</Hidden>
							</nav>
						}

						{ isMobile && browser.os !== 'ios' &&
						<WakeLock />
						}

						{ (currentNaviTab === 'home') &&
						<Home roomClient={roomClient} />
						}

						{ currentNaviTab === 'memo' &&
						<MemoPage />
						}

						{ currentNaviTab === 'call' &&
						<CallPage />
						}

						{ currentNaviTab === 'setting' &&
						<Setting />
						}

						{ currentNaviTab === 'todo' &&
						<ToDo />
						}

						{ currentNaviTab === 'calls' &&
						<CallHistory />
						}

						{ room.extraVideoOpen &&
						<ExtraVideo />
						}

						<BottomNavi
							fullscreenEnabled={this.fullscreen.fullscreenEnabled}
							fullscreen={this.state.fullscreen}
							onFullscreen={this.handleToggleFullscreen}
						/>

						{ room.callDialogOpen &&
						<OnCallDialog />
						}
						{ room.inviteDialogOpen &&
						<OnInviteDialog />
						}
						{ room.accessWarningDialogOpen &&
						<AccessWarningDialog />
						}
					</div>
				);
			}
		}
		else
		{
			return (
				<div className={classnames(
					useMobileView ? orientation === 'portrait' ? classes.rootUseMobile : classes.roomML
						: isMobile === true ?
							orientation === 'portrait' ? classes.rootM : classes.roomML
							:
							orientation === 'landscape' ? classes.rootGuest : classes.rootGuest
				)}
				>
					{ (isMobile) &&
						<img
							alt='logo'
							src='images/main_logo.png'
							className={orientation === 'portrait' ? classes.logo : classes.logoML}
						/>
					}
					{ !isElectron() &&
						<CookieConsent
							buttonText={
								<FormattedMessage
									id='room.consentUnderstand'
									defaultMessage='I understand'
								/>
							}
							style={{ display: 'none' }}
						>
							<FormattedMessage
								id='room.cookieConsent'
								defaultMessage='This website uses cookies to enhance the user experience'
							/>
						</CookieConsent>
					}

					<AudioPeers />

					{ showNotifications &&
						<Notifications />
					}

					<CssBaseline />

					<GuestHome />

					<GuestBottomNavi />

				</div>
			);
		}
	}
}

Room.propTypes =
{
	roomClient         : PropTypes.object.isRequired,
	room               : appPropTypes.Room.isRequired,
	browser            : PropTypes.object.isRequired,
	advancedMode       : PropTypes.bool.isRequired,
	showNotifications  : PropTypes.bool.isRequired,
	drawerOverlayed    : PropTypes.bool.isRequired,
	toolAreaOpen       : PropTypes.bool.isRequired,
	setToolbarsVisible : PropTypes.func.isRequired,
	toggleToolArea     : PropTypes.func.isRequired,
	setMakeCallEnd     : PropTypes.func.isRequired,
	setHolding         : PropTypes.func.isRequired,
	setRoomCall        : PropTypes.func.isRequired,
	setMemo            : PropTypes.func.isRequired,
	clearChat          : PropTypes.func.isRequired,
	classes            : PropTypes.object.isRequired,
	theme              : PropTypes.object.isRequired,
	currentNaviTab     : PropTypes.string.isRequired,
	isMobile           : PropTypes.bool.isRequired,
	useMobileView      : PropTypes.bool.isRequired,
	orientation        : PropTypes.string,
	chat               : PropTypes.array,
	peersLength        : PropTypes.number.isRequired,
	serviceStopped     : PropTypes.bool.isRequired
};

const mapStateToProps = (state) =>
	({
		room              : state.room,
		browser           : state.me.browser,
		advancedMode      : state.settings.advancedMode,
		showNotifications : state.settings.showNotifications,
		drawerOverlayed   : state.settings.drawerOverlayed,
		toolAreaOpen      : state.toolarea.toolAreaOpen,
		webcamDevices     : state.me.webcamDevices,
		currentNaviTab    : state.bottomNavigation.currentNaviTab,
		isMobile          : state.me.browser.platform === 'mobile' || state.me.useMobileView,
		orientation       : state.room.orientation ?
			state.room.orientation : state.me.useMobileOrientation,
		useMobileView  : state.me.useMobileView,
		chat           : state.chat,
		peersLength    : peersLengthSelector(state),
		serviceStopped : state.me.serviceStopped
	});

const mapDispatchToProps = (dispatch) =>
	({
		setToolbarsVisible : (visible) =>
		{
			dispatch(roomActions.setToolbarsVisible(visible));
		},
		toggleToolArea : () =>
		{
			dispatch(toolareaActions.toggleToolArea());
		},
		setMakeCallEnd : (bool) =>
		{
			dispatch(roomActions.setMakeCallEnd(bool));
		},
		setHolding : (bool) =>
		{
			dispatch(settingActions.setHolding(bool));
		},
		clearChat : () =>
		{
			dispatch(chatActions.clearChat());
		},
		setRoomCall : (call) =>
		{
			dispatch(roomActions.setRoomCall(call));
		},
		setMemo : (memo) =>
		{
			dispatch(roomActions.setMemo(memo));
		}
	});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room &&
				prev.room.orientation === next.room.orientation &&
				prev.me.browser === next.me.browser &&
				prev.settings.advancedMode === next.settings.advancedMode &&
				prev.settings.showNotifications === next.settings.showNotifications &&
				prev.settings.drawerOverlayed === next.settings.drawerOverlayed &&
				prev.toolarea.toolAreaOpen === next.toolarea.toolAreaOpen &&
				prev.toolarea.webcamDevices === next.toolarea.webcamDevices &&
				prev.bottomNavigation.currentNaviTab === next.bottomNavigation.currentNaviTab &&
				prev.me.serviceStopped === next.me.serviceStopped &&
				prev.me.useMobileView === next.me.useMobileView &&
				prev.me.useMobileOrientation === next.me.useMobileOrientation
			);
		}
	}
)(withStyles(styles, { withTheme: true })(Room));